import React from 'react'
import { ORANGE_TEXT_KEY } from '@mc/feature-variables'
import { UrgencyCopy, UrgencyCopyProps } from './UrgencyCopy'

export const UrgencyTextOrange = (props: Omit<UrgencyCopyProps, 'textKey'>) => (
  <UrgencyCopy {...props} textKey={ORANGE_TEXT_KEY} />
)
